import axios from "axios";

export const API_BASE_URL = "https://us-central1-maxpro-displays.cloudfunctions.net"
// export const API_BASE_URL = "http://localhost:5000/maxpro-displays/us-central1"

const axiosInstance = axios.create({
    baseURL: API_BASE_URL
});

export default axiosInstance;